import $ from "jquery";

/*
 * Pins a daterangepicker popup directly below its filter card, at the
 * card's exact width. Replaces the plugin's own move() so window resizes
 * and scrolling of the mobile content area keep it aligned.
 * Optional widthEl aligns the popup to a wider filter row for compact buttons.
 * Returns a cleanup function.
 */
export const alignPickerToFilter = (picker, filterEl, widthEl = filterEl) => {
  const GAP = 6;

  picker.move = function () {
    const rect = filterEl.getBoundingClientRect();
    const widthRect = widthEl.getBoundingClientRect();

    this.container.css({
      position: "fixed",
      top: `${rect.bottom + GAP}px`,
      left: `${widthRect.left}px`,
      right: "auto",
      transform: "none",
      width: `${widthRect.width}px`,
    });
  };

  const $scroller = $(filterEl).closest(".mobile-layout-content");
  const $filter = $(filterEl);
  const backdrop = document.createElement("div");
  backdrop.className = "mobile-daterangepicker-backdrop";
  backdrop.setAttribute("aria-hidden", "true");

  const showBackdrop = () => document.body.appendChild(backdrop);
  const hideBackdrop = () => backdrop.remove();
  const dismissPicker = () => picker.hide();

  backdrop.addEventListener("click", dismissPicker);
  $filter.on("show.daterangepicker.mobilePickerBackdrop", showBackdrop);
  $filter.on("hide.daterangepicker.mobilePickerBackdrop", hideBackdrop);

  const handleScroll = () => {
    if (picker.isShowing) picker.move();
  };

  $scroller.on("scroll.mobilePicker", handleScroll);

  return () => {
    $scroller.off("scroll.mobilePicker", handleScroll);
    $filter.off(".mobilePickerBackdrop");
    backdrop.removeEventListener("click", dismissPicker);
    hideBackdrop();
  };
};

/*
 * When a month or year dropdown changes, selects that whole month
 * (1st to last day) so the user only needs to press Apply.
 * Bound on the same .drp-calendar elements as the plugin's own
 * monthOrYearChanged handler, so it runs after the calendar has been
 * moved (and clamped) to the chosen month. That handler re-renders the
 * selects, so the event never bubbles past .drp-calendar.
 * Returns a cleanup function.
 */
export const selectWholeMonthOnChange = (picker) => {
  const $calendars = picker.container.find(".drp-calendar");

  const handleChange = (e) => {
    const isLeft = $(e.delegateTarget).hasClass("left");
    const month = (isLeft ? picker.leftCalendar : picker.rightCalendar).month;

    picker.startDate = month.clone().startOf("month");
    picker.endDate = month.clone().endOf("month");

    picker.updateCalendars();
    picker.updateFormInputs();
  };

  $calendars.on(
    "change.mobileMonthPick",
    "select.monthselect, select.yearselect",
    handleChange,
  );

  return () => $calendars.off(".mobileMonthPick");
};
